import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { extractExistingLine } from "@temp/components/ProductDetails/utils";
export var CheckoutRepositoryManager = function CheckoutRepositoryManager(repository, saleorState) {
  var _this = this;

  _classCallCheck(this, CheckoutRepositoryManager);

  this.getRepository = function () {
    return _this.repository;
  };

  this.addItemToCart = function (variantId, quantity, productAttributes) {
    var _this$saleorState$che;

    var lines = ((_this$saleorState$che = _this.saleorState.checkout) === null || _this$saleorState$che === void 0 ? void 0 : _this$saleorState$che.lines) || [];

    var _extractExistingLine = extractExistingLine(lines, variantId, productAttributes),
        _extractExistingLine2 = _slicedToArray(_extractExistingLine, 2),
        existingLine = _extractExistingLine2[0],
        alteredLines = _extractExistingLine2[1];

    var newVariantQuantity = existingLine ? existingLine.quantity + quantity : quantity;

    if (existingLine) {
      existingLine.quantity = newVariantQuantity;
      alteredLines.push(existingLine);
    } else {
      var newLine = {
        productAttributes: productAttributes,
        quantity: quantity,
        variant: {
          id: variantId
        }
      };
      alteredLines.push(newLine);
    }

    var alteredCheckout = _this.saleorState.checkout ? _objectSpread({}, _this.saleorState.checkout, {
      lines: alteredLines
    }) : {
      lines: alteredLines
    };

    _this.repository.setCheckout(alteredCheckout);

    return alteredCheckout;
  };

  this.removeItemFromCart = function (variantId, productAttributes) {
    var _this$saleorState$che2;

    var lines = ((_this$saleorState$che2 = _this.saleorState.checkout) === null || _this$saleorState$che2 === void 0 ? void 0 : _this$saleorState$che2.lines) || [];

    var _extractExistingLine3 = extractExistingLine(lines, variantId, productAttributes),
        _extractExistingLine4 = _slicedToArray(_extractExistingLine3, 2),
        existingLine = _extractExistingLine4[0],
        alteredLines = _extractExistingLine4[1];

    if (existingLine) {
      existingLine.quantity = 0;
      alteredLines.push(existingLine);
    }

    var alteredCheckout = _this.saleorState.checkout ? _objectSpread({}, _this.saleorState.checkout, {
      lines: alteredLines
    }) : {
      lines: alteredLines
    };

    _this.repository.setCheckout(alteredCheckout);

    return alteredCheckout;
  };

  this.updateItemInCart = function (variantId, quantity, productAttributes) {
    var _this$saleorState$che3;

    var lines = ((_this$saleorState$che3 = _this.saleorState.checkout) === null || _this$saleorState$che3 === void 0 ? void 0 : _this$saleorState$che3.lines) || [];

    var _extractExistingLine5 = extractExistingLine(lines, variantId, productAttributes),
        _extractExistingLine6 = _slicedToArray(_extractExistingLine5, 2),
        existingLine = _extractExistingLine6[0],
        alteredLines = _extractExistingLine6[1];

    if (existingLine) {
      existingLine.quantity = quantity;
      alteredLines.push(existingLine);
    }

    var alteredCheckout = _this.saleorState.checkout ? _objectSpread({}, _this.saleorState.checkout, {
      lines: alteredLines
    }) : {
      lines: alteredLines
    };

    _this.repository.setCheckout(alteredCheckout);

    return alteredCheckout;
  };

  this.setCartPromoCode = function (cartPromoCode) {
    var alteredCheckout = _objectSpread({}, _this.saleorState.checkout, {
      cartPromoCode: cartPromoCode
    });

    _this.repository.setCheckout(alteredCheckout);

    return alteredCheckout;
  };

  this.repository = repository;
  this.saleorState = saleorState;
};